import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Sprout } from 'lucide-react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Intro } from './components/Intro';
import { Modules } from './components/Modules';
import { CtaMid } from './components/CtaMid';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { ForWhom } from './components/ForWhom';
import { Pricing } from './components/Pricing';
import { Urgency } from './components/Urgency';
import { Closing } from './components/Closing';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
import { CountdownTimer } from './components/CountdownTimer';
export function App() {
  const [showTopBar, setShowTopBar] = useState(true);
  return <div className="w-full min-h-screen bg-cream relative" data-id="element-0">
      <AnimatePresence data-id="element-1">
        {showTopBar && <motion.div initial={{
        y: -50
      }} animate={{
        y: 0
      }} exit={{
        y: -50
      }} className="sticky top-0 z-50 w-full bg-lime-500 text-green-950 font-bold text-xs md:text-sm py-2 px-4 flex items-center justify-center gap-2 shadow-md" data-id="element-2">
            <Sprout className="w-4 h-4" data-id="element-3" />
            <span data-id="element-4">Oferta de lanzamiento — Hoy 67% OFF · Termina en </span>
            <CountdownTimer variant="small" data-id="element-5" />
            <button onClick={() => setShowTopBar(false)} className="absolute right-2 md:right-4 p-1 hover:bg-lime-600 rounded-full transition-colors" aria-label="Cerrar" data-id="element-6">
              <X className="w-4 h-4" data-id="element-7" />
            </button>
          </motion.div>}
      </AnimatePresence>

      <Hero data-id="element-8" />
      <SocialProof data-id="element-9" />
      <Intro data-id="element-10" />
      <Modules data-id="element-11" />
      <CtaMid data-id="element-12" />
      <Benefits data-id="element-13" />
      <Bonuses data-id="element-14" />
      <Testimonials data-id="element-15" />
      <ForWhom data-id="element-16" />
      <Pricing data-id="element-17" />
      <Urgency data-id="element-18" />
      <Closing data-id="element-19" />
      <Footer data-id="element-20" />
      <PurchasePopup data-id="element-21" />
      <MetaPixel data-id="element-22" />
    </div>;
}